import React, { useEffect, useState } from "react";
import { isEmpty } from "lodash";
import { Dispatch } from "@reduxjs/toolkit";
import { connect, ConnectedProps } from "react-redux";
// types
import TValidations from "cms/types/TValidations";
import TMenu from "cms/types/TMenu";
// actions
import ClientMenuItemServiceAction from "cms/actions/components/Header/ClientMenuItemServiceAction";
// interfaces
import IOdataQueryOptions from "core/interfaces/IOdataQueryOptions";
import IClientLanguage from "core/interfaces/IClientLanguage";
import IClientMenuItemList from 'cms/interfaces/IClientMenuItemList';
// enums
import { EContentStatus } from "cms/enums/EContentStatus";
// utilities
import MenuComposer from "cms/utilities/MenuComposer";
import LanguageVersionSelector from "cms/utilities/LanguageVersionSelector";
import { EView } from "cms/enums/EView";
import { EViewType } from "cms/enums/EViewType";
import { EContentType } from "cms/enums/EContentType";
import ILanguageVersionList from "cms/interfaces/ILanguageVersionList";
import RMDRNavLink from "components/RMDRNavLink";


function mapStateToProps ( state: any ) {
    console.log("HeaderMenu.mapStateToProps: ", state);

    const webApplicationLanguage:IClientLanguage   = state.CoreStore.language?.payload;
    const webApplicationLanguageCode:string        = webApplicationLanguage.code;
    const webApplicationLanguageISOCode:string     = state.CoreStore.languageCode?.payload;

    const clientMenuItemGet:IClientMenuItemList[]|null              = state.HeaderStore.ClientMenuItemStore.get?.["MNGRP001"];
    const clientMenuItemGetError:TValidations[]|null                = state.HeaderStore.ClientMenuItemStore.get?.error;
    const clientMenuItemGetIsLoading:boolean                        = state.HeaderStore.ClientMenuItemStore.get?.isLoading;

    return {

        webApplicationLanguage,
        webApplicationLanguageCode,
        webApplicationLanguageISOCode,

        clientMenuItemGet,
        clientMenuItemGetError,
        clientMenuItemGetIsLoading
    
    }
}

function mapDispatchToProps ( dispatch: Dispatch ) {
    console.log("HeaderMenu.mapDispatchToProps");

    const clientMenuItemServiceAction = new ClientMenuItemServiceAction(dispatch);

    return {
        
        _getClientMenuItems: ( webApplicationLanguageCode:string, mapLayoutName:string, destinationName:string ) => {
            let queryOptions:IOdataQueryOptions = {
                filter: [`mapLayoutName eq '${mapLayoutName}'`, "and", `status eq ${EContentStatus.ACTIVE}`],
                orderBy: ["order asc"],
                top: 1000
            };

            clientMenuItemServiceAction.get({ 
                servicePayload: { queryOptions, language: webApplicationLanguageCode },
                args: { storeMapOptions: [{ destinationName, sourceName: "value" }]  } 
            });
        }

    }
}

const connector = connect(mapStateToProps, mapDispatchToProps);


/* types */
type PropsFromRedux = ConnectedProps<typeof connector>
type TMenuProps<T> = {

    onClick: (event:React.MouseEvent<HTMLDivElement|HTMLSpanElement>, contentId:string) => void;

} & T;


/* component */
function HeaderMenuLoader () {

    return (
        <></>
    )

}

function HeaderMenu ( props:TMenuProps<PropsFromRedux> ) {

    const [ navigation, setNavigation ] = useState<TMenu[]|null>(null);

    useEffect(
        () => {
            if ( !isEmpty(props.webApplicationLanguageCode)) {
                props._getClientMenuItems(props.webApplicationLanguageCode, "MNGRP_001", "MNGRP001");
            }
        }, [ props.webApplicationLanguageCode ]
    )

    useEffect(
        () => {

            if ( !isEmpty(props.clientMenuItemGet) ) {
                let parentMenuItems = props.clientMenuItemGet?.filter((item:any) => item.parentId === null);
                let navigation = MenuComposer(props.clientMenuItemGet, parentMenuItems);
                setNavigation(navigation);
            }

        }, [ props.clientMenuItemGet ]
    )


    return (
        <ul className="main-menu__list">
            {
                navigation?.map((item, index) => {
                    const languageVersion = LanguageVersionSelector<ILanguageVersionList>({
                        languageVersions: item.languageVersions,
                        filters:[{ view: EView.OUTTER, viewType: EViewType.NAME_DESCRIPTION, contentType: EContentType.DEFAULT }],
                        type: "find"
                    });

                    const redirectUrl = LanguageVersionSelector<ILanguageVersionList>({
                        languageVersions: item.languageVersions,
                        filters:[{ view: EView.META_DATA, viewType: EViewType.TEXT, contentType: EContentType.DEFAULT, name: "redirectUrl" }],
                        type: "find"
                    });

                    return (
                        <li key={item.id} className={`${item?.items && item.items?.length > 0 ? "dropdown" : ""}`}>
                            <RMDRNavLink
                                title={languageVersion?.name}
                                text={languageVersion?.name}
                                navigationURL={languageVersion.contentRouteNavigationURL}
                                hasNavigationDestination={item.hasDestinationNavigation}
                                isShowAlways={true}

                                redirectType={item.redirectType}
                                redirectUrl={redirectUrl?.value}

                                onClick={(event:any) => { props.onClick(event, item.id) }}
                                variant="div"
                            />
                            {
                                item?.items && item.items?.length > 0 ? 
                                    (
                                        <ul>
                                            {
                                                item.items.map((cItem) => {
                                                    const cLanguageVersion = LanguageVersionSelector<ILanguageVersionList>({
                                                        languageVersions: cItem.languageVersions,
                                                        filters:[{ view: EView.OUTTER, viewType: EViewType.NAME_DESCRIPTION, contentType: EContentType.DEFAULT }],
                                                        type: "find"
                                                    });
                            
                                                    const cRedirectUrl = LanguageVersionSelector<ILanguageVersionList>({
                                                        languageVersions: cItem.languageVersions,
                                                        filters:[{ view: EView.META_DATA, viewType: EViewType.TEXT, contentType: EContentType.DEFAULT, name: "redirectUrl" }],
                                                        type: "find"
                                                    });

                                                    return (
                                                        <li key={item.id}>
                                                            <RMDRNavLink
                                                                title={cLanguageVersion?.name}
                                                                text={cLanguageVersion?.name}
                                                                navigationURL={cLanguageVersion.contentRouteNavigationURL}
                                                                hasNavigationDestination={cItem.hasDestinationNavigation}
                                                                isShowAlways={true}
                                
                                                                redirectType={cItem.redirectType}
                                                                redirectUrl={cRedirectUrl?.value}

                                                                onClick={(event:any) => { props.onClick(event, item.id) }}
                                                                variant="div"
                                                            />
                                                        </li>
                                                    )
                                                })
                                            }
                                        </ul>
                                    ) : null
                            }
                        </li>
                    );
                })
            }
        </ul>
    );

};

const Component = React.memo(HeaderMenu, ( prevProps:TMenuProps<PropsFromRedux>, nextProps:TMenuProps<PropsFromRedux> ) => {
    console.log("HeaderMenu.memo", { prevProps, nextProps });

    return !(
        prevProps.clientMenuItemGet !== nextProps.clientMenuItemGet
    );
});

export default connector(Component);
